<template>
    <div class="facturacion">
        <vx-card>
            <h2 class="mb-2">Facturación</h2>
            <p class="mb-2">Consulta este <a :href="$sanitizeUrl(blogUrl)" target="_blank" rel="noopener noreferrer" class="black underline">artículo</a> para saber más sobre los comprobantes que necesitas para cumplir con tus obligaciones fiscales.</p>
            <!-- filtros -->
            <div class="vx-row mb-base">
                <div class="vx-col sm:w-full md:w-1/4">
                    <label class="mb-0 bold" for="">Año</label>
                        <v-select
                            label="text"
                            v-model.lazy="currentYear"
                            class="vs-custom w-full"
                            v-validate="'required'"
                            name="sourceType"
                            placeholder="Seleccione una opción"
                            :clearable="false"
                            :searchable="true"
                            :options="getYearsOptions"
                            :reduce="text => text.value"
                            >
                        <div slot="no-options">No hay coincidencias</div> 
                    </v-select>
                </div>
                <div class="vx-col sm:w-full md:w-1/4">
                    <label class="mb-0 bold" for="">Mes</label>
                        <v-select
                            label="text"
                            v-model.lazy="currentMonth"
                            class="vs-custom w-full"
                            v-validate="'required'"
                            name="sourceType"
                            placeholder="Seleccione una opción"
                            :clearable="false"
                            :searchable="true"
                            :options="getMonthOptions"
                            :reduce="text => text.value"
                            >
                        <div slot="no-options">No hay coincidencias</div> 
                    </v-select>
                </div>
                <div class="vx-col sm:w-full md:w-1/3 mt-4">
                    <div class="flex">
                        <vs-button :disabled="currentMonth == null || currentYear == null" class="p-4 mr-2" @click.stop="getInvoices">Consultar</vs-button>
                        <vs-button @click.stop="doDownloadZipInvoices" :disabled="selected.length == null" class="p-4">Descargar Zip</vs-button>
                    </div>
                </div>
            </div>
            <!-- FACTURAS -->
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-table 
                        ref="invoices_table" 
                        :data="loans" 
                        stripe 
                        multiple 
                        v-model="selected"
                        noDataText="No se han generado registros">
                        <template slot="thead">
                            <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :id="indextr" :data="tr" key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>
                                    {{ tr.alias }} ({{ tr.project_id }})
                                </vs-td>
                                <vs-td>
                                    {{ costFormat(tr.balance_total) }}
                                    <div @click.stop="doSingleDownloadZipInvoices(tr.project_id, tr)" class="text-sm underline hover:text-primary">
                                        <small>ZIP <feather-icon icon="DownloadIcon" svgClasses="w-3 h-3 hover:text-primary stroke-current cursor-pointer" class="ml-1" /></small>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    {{ costFormat(tr.balance_amortizations) }}
                                </vs-td>
                                <vs-td>
                                    <!-- {{ costFormat(tr.invoices_resume_F?.invoice_amount_total) || '$0.00' }} -->
                                      {{ tr.invoices_resume_F.length > 0? costFormat(tr.invoices_resume_F[0].invoice_amount_total) : '$0.00' }}
                                    <div v-if="tr.invoices_resume_F.length > 0">
                                        <div @click.stop="doDownloadDocumentInvoice(tr.invoices_resume_F[0], tr.project_id, 'pdf')" class="text-sm underline hover:text-primary">
                                            <small>PDF <feather-icon icon="DownloadIcon" svgClasses="w-3 h-3 hover:text-primary stroke-current cursor-pointer" class="ml-1" /></small>
                                        </div>
                                        <div @click.stop="doDownloadDocumentInvoice(tr.invoices_resume_F[0], tr.project_id, 'xml')" class="text-sm underline hover:text-primary">
                                            <small>XML <feather-icon icon="DownloadIcon" svgClasses="w-3 h-3 hover:text-primary stroke-current cursor-pointer" class="ml-1" /></small>
                                        </div>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <!-- {{ costFormat(tr.invoices_resume_T?.invoice_amount_total) || '$0.00' }} -->
                                      {{ tr.invoices_resume_T.length > 0? costFormat(tr.invoices_resume_T[0].invoice_amount_total) : '$0.00' }}
                                      <template v-if="tr.invoices_resume_T.length > 0">
                                          <div @click.stop="doDownloadDocumentInvoice(tr.invoices_resume_T[0], tr.project_id, 'pdf')" class="text-sm underline hover:text-primary">
                                              <small>PDF <feather-icon icon="DownloadIcon" svgClasses="w-3 h-3 hover:text-primary stroke-current cursor-pointer" class="ml-1" /></small>
                                          </div>
                                          <div @click.stop="doDownloadDocumentInvoice(tr.invoices_resume_T[0], tr.project_id, 'xml')" class="text-sm underline hover:text-primary">
                                              <small>XML <feather-icon icon="DownloadIcon" svgClasses="w-3 h-3 hover:text-primary stroke-current cursor-pointer" class="ml-1" /></small>
                                          </div>
                                      </template>
                                </vs-td>
                                <vs-td>
                                    {{ costFormat(tr.tax_pf) }}
                                    <div @click.stop="doDownloadStatementPdf(tr)" class="text-sm underline hover:text-primary">
                                        <small>PDF <feather-icon icon="DownloadIcon" svgClasses="w-3 h-3 hover:text-primary stroke-current cursor-pointer" class="ml-1" /></small>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    {{ costFormat(tr.balance_commissions) }}
                                    <div @click.stop="doDownloadStatementPdf(tr)" class="text-sm underline hover:text-primary">
                                        <small>PDF <feather-icon icon="DownloadIcon" svgClasses="w-3 h-3 hover:text-primary stroke-current cursor-pointer" class="ml-1" /></small>
                                    </div>
                                    <!-- <div class="text-sm underline hover:text-primary">
                                        <small>XML <feather-icon icon="DownloadIcon" svgClasses="w-3 h-3 hover:text-primary stroke-current cursor-pointer" class="ml-1" /></small>
                                    </div> -->
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

const monthOptions = [
    { value:"01", text: "ENERO" },
    { value:"02", text: "FEBRERO" },
    { value:"03", text: "MARZO" },
    { value:"04", text: "ABRIL" },
    { value:"05", text: "MAYO" },
    { value:"06", text: "JUNIO" },
    { value:"07", text: "JULIO" },
    { value:"08", text: "AGOSTO" },
    { value:"09", text: "SEPTIEMBRE" },
    { value:10, text: "OCTUBRE" },
    { value:11, text: "NOVIEMBRE" },
    { value:12, text: "DICIEMBRE" }
];

const monthOptions2024 = [
    { value:11, text: "NOVIEMBRE" },
    { value:12, text: "DICIEMBRE" }
];

const columns = [
    { title: "CRÉDITO", key: "loan_ind", sortable: false }
    , { title: "PAGO TOTAL", key: "payment", sortable: false }
    , { title: "AMORTIZACIÓN", key: "amortization", sortable: false }
    , { title: "INTERESES RG", key: "tax_rg", sortable: false }
    , { title: "INTERESES PM", key: "tax", sortable: false }
    , { title: "INTERESES PF", key: "tax_pf", sortable: false }
    , { title: "COMISIONES", key: "commission", sortable: false }
];

import formatHelper from '@mixins/formatHelper';

export default {
    name: "InvoiceManagementPage",
    mixins: [formatHelper],
    data: () => ({
        blogUrl: "https://soporte.redgirasol.com/support/solutions/articles/48001270751-todo-sobre-las-facturas-de-tus-pagos",
        currentYear: null,
        currentMonth: null,
        monthOptions: monthOptions,
        monthOptions2024: monthOptions2024,
        columns: columns,
        selected: [],
        loans: []
    }),
    props: {
        source: String
    },
    computed: {
        getYearsOptions() {
            const years = [];
            for (let i = new Date().getFullYear(); i >= 2024; i--) {
                years.push({ text: i, value: i });
            }

            return years;
        },
        getMonthOptions() {
            return this.currentYear == 2024 ? this.monthOptions2024 : this.monthOptions;
        },
        isMoral() {
            return this.UserPersonType == 0 || this.UserPersonType == 3;
        },
    },
    methods: {
        async getInvoices() {
            const date = `${this.currentYear}-${this.currentMonth}-01`;
            this.showLoading(true);
            try {
                const res = await axios.get(`/api/applicant-invoices/get/data/${this.ApplicantId}?d=${date}`);
                this.loans = res.data;
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            } finally {
                this.showLoading(false);
            }
        },
        async doDownloadDocumentInvoice(invoice, projectId, type){
            try {
                let url = `${this.ApiDomain}/api/invoices/get/loan-invoice/${invoice.id}?access_token=${this.AccessToken}&loan_id=${projectId}&type=${type}`;
                window.open(url, "_blank");
            }
            catch (e) {
                this.warn(e)
                this.showError(e);
            }
        },
        async doSingleDownloadZipInvoices(projectId, invoice) { 
            try {
                let statementsIdsT = invoice.invoices_resume_T.map((item) => item.invoice_id);
                let statementsIdsF = invoice.invoices_resume_F.map((item) => item.invoice_id);
                const ids = statementsIdsT.concat(statementsIdsF);
                let statementsIds = [...new Set(ids)];
                let idsEncoded = encodeURIComponent(JSON.stringify(statementsIds));
                let url = `${this.ApiDomain}/api/invoices/get/loan-invoice/zip?access_token=${this.AccessToken}&loan_id=${projectId}&invoice_ids=${idsEncoded}&is_multiple=false`;
                window.open(url, "_blank");
            } catch (e) {
                if (e.response?.data?.message != undefined) {
                this.errorNotif("Aviso", e.response.data.message, 4000);
                } else {
                this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                }
            }
        },
        async doDownloadZipInvoices() { 
            if (this.selected.length == 0) {
                this.errorNotif("Aviso", 'No hay facturas seleccionadas', 4000);
                return;
            }
            try {
                let statementsIds = [];
                let projectId = this.selected[0].project_id;
                this.selected.forEach(invoice => {
                    let statementsIdsT = invoice.invoices_resume_T.map((item) => item.invoice_id);
                    let statementsIdsF = invoice.invoices_resume_F.map((item) => item.invoice_id);
                    const ids = statementsIdsT.concat(statementsIdsF);
                    statementsIds = statementsIds.concat(ids);
                });

                let allStatementIds = [...new Set(statementsIds)];
                let idsEncoded = encodeURIComponent(JSON.stringify(allStatementIds));
                let url = `${this.ApiDomain}/api/invoices/get/loan-invoice/zip?access_token=${this.AccessToken}&loan_id=${projectId}&invoice_ids=${idsEncoded}&is_multiple=false`;
                window.open(url, "_blank");
            } catch (e) {
                if (e.response?.data?.message != undefined) {
                this.errorNotif("Aviso", e.response.data.message, 4000);
                } else {
                    console.log(e);
                this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                }
            }
        },
        async doDownloadStatementPdf(invoice){
            try {
                let url = `${this.ApiDomain}/api/invoices/get/loan-statement/${invoice.statement.id}/download/${this.ApplicantId}?access_token=${this.AccessToken}`;
                window.open(url, "_blank");
                // se genera log de accion
                this.saveApplicantLogAction("LC12-26");
            }
            catch (e) {
                this.warn(e)
                this.showError(e);
            }
        },
    }
}
</script>

<style>
.vs-table--thead tr{
    background: #E0FFDD;
}
</style>